//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import StrengthMeterPassword from '~/components/UI/Inputs/StrengthMeterPassword';
import Stepper from '~/components/Pages/Register/Stepper';

export default {
    name: 'RegisterIndex',
    components: {
        Stepper,
        StrengthMeterPassword,
    },
    layout: 'register',
    data() {
        return {
            first_name: null,
            last_name: null,
            email: '',
            password: '',
            showErrors: false,
        };
    },
    head() {
        return {
            title: `Holi - ${this.$t('core.register_company')}`,
        };
    },
    methods: {
        setPassword(val) {
            this.password = val;
        },
        async onSubmit() {
            let isRegistrationSuccessful = false;

            await this.$axios
                .post(`/auth/register`, {
                    first_name: this.first_name,
                    last_name: this.last_name,
                    email: this.email,
                    password: this.password,
                })
                .then((res) => {
                    if (res.data.success === 1) {
                        isRegistrationSuccessful = true;
                    } else {
                        this.$refs.form.setErrors(res.data.error);
                        this.showErrors = true;
                    }
                })
                .catch((err) => {
                    console.log(err);
                });

            if (!isRegistrationSuccessful) {
                return;
            }

            this.$axios
                .$post('/auth/login', {
                    email: this.email,
                    password: this.password,
                })
                .then((res) => {
                    if (res.success === 1) {
                        this.$store.dispatch('auth/logIn', { user: res.user, token: res.token });
                        this.$router.push(this.localePath('/register/company'));
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },
    },
};
